import React from "react";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

/**
 * Skeleton loading state for VehicleSelectionCard.
 * Mimics the layout of the actual card while loading.
 */
export const VehicleSelectionCardSkeleton: React.FC = () => {
  return (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Skeleton variant="rectangular" width={24} height={24} sx={{ borderRadius: 0.5 }} />
        <Skeleton variant="circular" width={24} height={24} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="60%" height={24} />
          <Skeleton variant="text" width="40%" height={20} />
        </Box>
      </Box>
    </Card>
  );
};

export default VehicleSelectionCardSkeleton;
